module.exports = __webpack_public_path__ + "media/images/icons/SVG/032-7f8b80f829dbed0fc865f599d5a5a83c.svg";